import { AppState } from '../types/AppState';
import { DateRange } from '../types/DateRange';

export const getDateRangeOrUndefined = (appState: AppState): DateRange | undefined => appState.orders.dateRange;
